module.exports = __webpack_public_path__ + "static/media/thumbnail.1dacc87f.svg";